import { Link } from "react-router-dom";

export default function Cta() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 pb-14 md:pb-20">
      <div className="relative overflow-hidden rounded-2xl border border-primary-500/30 bg-background-200 px-6 py-12 md:px-12 md:py-16">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=swirling%20ember%20and%20ash%20particles%20rising%20in%20a%20dark%20void%2C%20warm%20orange%20fire%20glow%20with%20deep%20charcoal%20shadow%2C%20abstract%20textured%20background%2C%20cinematic%20and%20atmospheric&width=1600&height=600&seq=cta-ember&orientation=landscape"
            alt=""
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative z-10 flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              准备好了吗？开始你的追更之旅
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-400">
              从长篇连载到冷门短篇，同人世界的大门已经为你打开。按目录快速找到想看的作品，追更不迷路。
            </p>
          </div>
          <Link
            to="/works"
            className="flex shrink-0 items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-search-line" />
            进入同人作品库
          </Link>
        </div>
      </div>
    </section>
  );
}